import React, { ReactNode } from 'react';
import Image, { StaticImageData } from 'next/image';
import { SpacerComponent } from '@components/Spacer';
import { Heading1 } from '@components/web-landingpage/Texts';

function UserAdmissionBanner({
  text,
  alt,
  src,
}: {
  text: string | ReactNode;
  alt: string;
  src: StaticImageData;
}) {
  return (
    <div className="flex flex-col items-center">
      <div className="flex w-full justify-center">
        <Image
          className="h-[200px] max-w-[300px]"
          alt={alt}
          src={src}
          sizes="(min-width: 0px) 300px"
        ></Image>
      </div>
      <SpacerComponent className="h-3 sm:h-6"></SpacerComponent>
      <Heading1 className="whitespace-pre-line text-center text-[20px] text-product-text-primary-light dark:text-marketing-text-primary tablet:text-[24px]">
        {text}
      </Heading1>
    </div>
  );
}

export default UserAdmissionBanner;
